import { useEffect, useState } from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Invite() {
  const { token } = useParams();
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/invitations/lookup/${token}`).then((r) => { setInv(r.data); setName(r.data.name || ""); })
      .catch((e) => setErr(apiError(e)));
  }, [token]);

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (!name || password.length < 8) return toast.error("Name required, password ≥ 8 chars");
    setBusy(true);
    try {
      const { data } = await api.post(`/invitations/lookup/${token}/accept`, { name, password });
      if (data.token) localStorage.setItem("sq_token", data.token);
      toast.success(`Welcome to ${data.tenant.name}`);
      await refresh(); nav("/dashboard");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#FBFBF9] px-4">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <div className="font-display font-extrabold text-2xl text-slate-900">RiskEye <span className="text-sm font-normal text-slate-500">by seQure</span></div>
          <div className="text-xs uppercase tracking-widest font-mono text-cyan-700 mt-1">Complete your registration</div>
        </div>
        {err ? (
          <div className="rounded-lg border border-rose-200 bg-rose-50 p-4 text-sm text-rose-800" data-testid="invite-error">{err}</div>
        ) : !inv ? (
          <div className="text-center text-slate-500 font-mono text-xs">Loading invitation…</div>
        ) : (
          <form onSubmit={submit} className="rounded-xl bg-white border border-slate-200 p-6 shadow-sm" data-testid="invite-form">
            <div className="text-xs text-slate-500 mb-4">You've been invited to join <span className="font-semibold text-slate-900">{inv.tenant?.name}</span> as <span className="font-mono font-semibold text-cyan-800">{inv.role}</span>.</div>
            <div className="space-y-3">
              <div><Label>Email</Label><Input value={inv.email} disabled className="bg-slate-50 font-mono" /></div>
              <div><Label>Full name</Label><Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="invite-name" /></div>
              <div><Label>Password (≥ 8 chars)</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} data-testid="invite-password" /></div>
              <Button type="submit" disabled={busy} className="w-full bg-[#0A1329] hover:bg-[#162347] text-white h-11" data-testid="invite-submit">{busy ? "Creating account…" : "Accept & sign in"}</Button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
